import CosmicModule from '@finn/auto-ui/ui-modules/CosmicModule';
import { Modal, ModalContent } from '@finn/design-system/atoms/modal';
import { ModalKey, useCloseModal, useIsModalOpen } from '@finn/ua-modals';
import { ModuleType } from '@finn/ui-cosmic';

type DynamicModalProps = {
  name?: string;
  module?: ModuleType & { metadata?: { isInModal?: boolean } };
  variant?: 'small' | 'large';
};

export const DynamicModal = ({
  name,
  module,
  variant = 'small',
}: DynamicModalProps) => {
  const isPDPConfigModalOpen = useIsModalOpen(name as ModalKey);
  const closeModal = useCloseModal();

  if (module?.metadata) {
    module.metadata.isInModal = true;
  }

  if (!module) {
    return null;
  }

  return (
    <Modal
      variant={variant}
      open={isPDPConfigModalOpen}
      onOpenChange={(open) => {
        if (!open) {
          closeModal(name as ModalKey);
        }
      }}
    >
      <ModalContent>
        <CosmicModule data={module} />
      </ModalContent>
    </Modal>
  );
};
